/**
 * Little Rituals - Lenis Smooth Scroll Engine
 * Configured with strict E-Commerce safeguards:
 * 1. prefers-reduced-motion compliance
 * 2. Pure native touch preservation on mobile devices (no scroll-hijack)
 * 3. Automatic pause/resume when Cart Drawer or navigation modals open
 */
(function() {
  'use strict';

  // 1. Accessibility guard: do nothing if user prefers reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  // 2. Mobile guard: keep native hardware momentum on touchscreen phones/tablets
  if (window.matchMedia('(pointer: coarse)').matches) {
    return;
  }

  function initLenis() {
    if (typeof Lenis === 'undefined') return;

    var lenis = new Lenis({
      duration: 1.15,
      easing: function(t) {
        return Math.min(1, 1.001 - Math.pow(2, -10 * t));
      },
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 0.9,
      syncTouch: false,
      infinite: false
    });

    window.lenis = lenis;

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // 3. Cart Drawer & Modal Guard: Pause scroll when drawers or modals are open
    var observer = new MutationObserver(function() {
      var isDrawerOpen = document.querySelector('.cart-drawer.active, .menu-drawer[open], .drawer.active, modal-dialog[open], body.overflow-hidden');
      if (isDrawerOpen) {
        lenis.stop();
      } else {
        lenis.start();
      }
    });

    observer.observe(document.body, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class', 'open']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLenis);
  } else {
    initLenis();
  }
})();
